import Router from "./routes/Router";

function App() {
// console.log('LIVE CODE: 05 October 2026');
  return (
    <>
      <Router />
    </>
  );
}

export default App;
